module.exports = __webpack_public_path__ + "img/Filter_Line_16px_Icon-disabled.7f0ae535.svg";